import MypageOrderContainer from './MypageOrderContainer';
export default MypageOrderContainer;